import IApiResponse from "../../interfaces/IApiResponse";
import SuccessApiResponse from "../../data/SuccessApiResponse";
import IReadingPlanRecord from "../../interfaces/IReadingPlanRecord";
import { IReadingPlanRecordService } from "../ReadingPlanRecordService";
import { SQLiteTables } from "../../data/SQLiteTables";
import SQLiteHelperService from "../SQLiteHelperService";
import SQLiteDB from "../../data/SQLiteDB";
import ISQLiteResponse from "../../interfaces/ISQLiteResponse";

const dbFailedResponse = Promise.resolve({
    Data: undefined,
    Success: false,
    Message: { UserMessage: 'db not connected', ServerMessage: 'db not connected' }});

const ReadingPlanRecordServiceHybrid: IReadingPlanRecordService = {
    
    createReadingPlanRecord: async (readingPlanRecord) => {
        const newRecord: any = {...readingPlanRecord};
        newRecord.modifiedDate = new Date(Date.now());
        delete newRecord.id;
        const query = SQLiteHelperService.insertQuery(SQLiteTables.readingPlanRecords , newRecord);
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IReadingPlanRecord>> = db.executeSql(query, []).then((result:ISQLiteResponse<IReadingPlanRecord>)=>{
                    newRecord.id = result.insertId;
                    const response = {...SuccessApiResponse, Data: newRecord};
                    response.Message.UserMessage = 'SUCCESS: SAVED PLAN.';
                    console.log('Success: Created Reading Plan Record - ', response);
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: newRecord,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.error('SQL - Failed to Insert Record: ', error);
                return response as IApiResponse<IReadingPlanRecord>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getReadingPlanRecord: async (activeReadingPlanId: number) =>  {
        const query = `SELECT * FROM ${SQLiteTables.readingPlanRecords} WHERE \`id\`=${activeReadingPlanId}`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IReadingPlanRecord>> = db.executeSql(query, []).then((result:ISQLiteResponse<IReadingPlanRecord>)=>{
                if(result.rows.length) {                  
                    return  {...SuccessApiResponse, Data: SQLiteHelperService.convertToJsTypes(result.rows.item(0))};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND READING PLAN RECORD', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.error('SQL - Failed to Get Record: ', error);
                return response as IApiResponse<IReadingPlanRecord>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getReadingPlanRecords: async () =>  {
        const query = `SELECT * FROM ${SQLiteTables.readingPlanRecords}`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IReadingPlanRecord[]>> = db.executeSql(query, []).then((result:ISQLiteResponse<IReadingPlanRecord[]>)=>{
                if(result.rows.length) {                  
                    return  {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(result, true)};
                } else {
                    return {
                        Data: [],
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND READING PLAN RECORDS', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: [],
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.error('SQL - Failed to Get Record: ', error);
                return response as IApiResponse<IReadingPlanRecord[]>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    updateReadingPlanRecord: async (readingPlanRecord, isSyncUpdate?) => {
        // If this an update from a cloud sync don't modify the date
        const updateRecord = isSyncUpdate ? {...readingPlanRecord} : {...readingPlanRecord, modifiedDate: new Date(Date.now())};
        const query = SQLiteHelperService.updateQuery(SQLiteTables.readingPlanRecords, updateRecord);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IReadingPlanRecord>> = db.executeSql(query, []).then((result)=>{
                const response = {...SuccessApiResponse, Data: updateRecord};
                response.Message.UserMessage = 'SUCCESS: UPDATED PLAN';
                return response;
            }).catch((error)=>{
                const response = {
                    Data: updateRecord,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.error('SQL - Failed to Update Record: ', error);
                return response as IApiResponse<IReadingPlanRecord>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    deleteReadingPlanRecord: async (recordId) => {

        const query = `DELETE FROM ${SQLiteTables.readingPlanRecords} WHERE \`id\`=${recordId}`
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<boolean>> = db.executeSql(query, []).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            }).catch((error)=>{
                const response = {
                    Data: false,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<boolean>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },
}

export default ReadingPlanRecordServiceHybrid;